/**
 * isHarmlessScannerError — true for known-benign rejections from the
 * html5-qrcode library's internal play() / scan-loop machinery.
 *
 * These rejections are emitted by Chromium and Safari any time the <video>
 * element's MediaStream is replaced or torn down between init and play
 * (StrictMode double-mount, route navigation cycles, idle restart timers,
 * the library's own pause/resume cycling). They are NOT bugs in our code
 * and surfacing them to the dev overlay just adds noise.
 *
 * IMPORTANT: keep this list TIGHT. Real failures the staff must see —
 * permission denied, no camera, camera in use — must NOT match.
 */
const HARMLESS_PATTERNS = [
  /play\(\) request was interrupted/i,
  /media was removed from the document/i,
  /the request is not allowed by the user agent/i,
  /the operation was aborted/i,
  /\babort(ed|error)\b/i,
];

export function isHarmlessScannerError(err) {
  if (!err) return false;
  // DOMException AbortError has a `.name` we can check first (top-level
  // OR nested under .reason for unhandledrejection events).
  if (err.name === "AbortError") return true;
  if (err.reason && err.reason.name === "AbortError") return true;
  const msg =
    typeof err === "string"
      ? err
      : err.message
        ? String(err.message)
        : err.reason
          ? String(err.reason.message || err.reason)
          : "";
  if (!msg) return false;
  return HARMLESS_PATTERNS.some((re) => re.test(msg));
}

export default isHarmlessScannerError;
